module.exports = __webpack_public_path__ + "img/2024-03-19d_1.aaf9076b.jpg";